import { render, staticRenderFns } from "./Propiedades.vue?vue&type=template&id=4435e8e0"
import script from "./Propiedades.vue?vue&type=script&lang=js"
export * from "./Propiedades.vue?vue&type=script&lang=js"
import style0 from "./Propiedades.vue?vue&type=style&index=0&id=4435e8e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports